export default "__VITE_ASSET__747b4b51__"